/**
 * Сборка ответа блока из нескольких пунктов (несколько картинок, слов,
 * предложений в одном задании).
 *
 * Ответ блока уходит на сервер, только когда известен результат КАЖДОГО пункта.
 *
 * ⚠️ ДЕФЕКТ, РАДИ КОТОРОГО ЭТО ВЫНЕСЕНО (10.09.2026). Восстановленные после
 * перезагрузки пункты молчали — и правильно, повторно слать сохранённое незачем.
 * Но о них не знал и сборщик. Ученик возвращался в урок, исправлял один
 * неверный пункт — сборщик видел `[пусто, верно, пусто]` и не отправлял ничего:
 * на экране «верно», в базе прежнее «неверно». На копии боевой базы у анаграмм
 * 209 из 210 неверных ответов так и остались с первой попытки.
 *
 * Лечение: восстановленный пункт сообщает свой результат с `send = false` —
 * сборщик его запоминает, но на сервер не шлёт.
 */

export type ItemResults = { ok: (boolean | null)[]; data: (string | null)[] };

export type BlockPayload = { answer_data: string; is_correct: boolean };

export const emptyResults = (count: number): ItemResults => ({
  ok: Array(count).fill(null),
  data: Array(count).fill(null),
});

/**
 * Записать результат пункта. `payload` — что отправить на сервер, или `null`,
 * если отправлять нечего: пункты известны не все, либо это засев (`send = false`).
 *
 * Однопунктовый блок отдаёт сырое значение пункта (так его ждёт серверная
 * проверка), многопунктовый — JSON-массив значений.
 */
export function recordItem(
  prev: ItemResults,
  index: number,
  correct: boolean,
  data: string,
  single: boolean,
  send: boolean,
): { next: ItemResults; payload: BlockPayload | null } {
  if (index < 0 || index >= prev.ok.length) return { next: prev, payload: null };
  const ok = [...prev.ok];
  const d = [...prev.data];
  ok[index] = correct;
  d[index] = data;
  const next = { ok, data: d };
  if (!send || !ok.every((r) => r !== null)) return { next, payload: null };
  return {
    next,
    payload: {
      answer_data: single ? (d[0] ?? '') : JSON.stringify(d),
      is_correct: ok.every(Boolean),
    },
  };
}
